export default __webpack_public_path__ + "static/media/Mark-5-HUD-04.17d79989.jpg";